export default "__VITE_ASSET__CRrnV8rw__"